export default __webpack_public_path__ + "static/media/logo.2b1feb81.png";